const renderableBusinessNotificationTypes = new Set([
    'kycVerificationNeeded',
    'kycFutureVerificationNeeded',
    'bankAccountMDVerificationStarted'
]);
export const isRenderableNotification = (notification)=>{
    if (notification.type === 'business') {
        return renderableBusinessNotificationTypes.has(notification.business.type);
    }
    return true;
};
export const getVisibleNotifications = (notifications)=>notifications.filter(isRenderableNotification);
